import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { useEffect, useCallback, useState } from 'react';
import { getDocument } from 'pdfjs-dist/build/pdf';
import { setPdfWorker } from '../utils/helpers';
import PdfjsWorker from 'pdfjs-dist/build/pdf.worker';
setPdfWorker(PdfjsWorker);

var EditorPdfLoader = function EditorPdfLoader(_ref) {
  var file = _ref.file,
      loading = _ref.loading,
      onLoadSuccess = _ref.onLoadSuccess,
      children = _ref.children;

  var _useState = useState(!!file),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var load = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            getDocument({
              url: file,
              eventBusDispatchToDOM: true
            }).promise.then(function (pdfDocument) {
              onLoadSuccess(pdfDocument);
              setIsLoading(false);
            })["catch"](function () {
              setIsLoading(false);
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [file, onLoadSuccess]);
  useEffect(function () {
    if (file) {
      load();
    }
  }, [file]);
  if (isLoading) return loading;
  return children;
};

export default EditorPdfLoader;